const appConstants = {
  comments: ['Creating an offer is very simple. Just head to Offer Manager > Offer and set up exclusive offers for your customers!',
    'If you run out of stock for an item, you can quickly turn it off. Just go to Product On-Off and set its availability with one click!',
    'Continuously track the performance of your Brand and its outlets and take pro decisions. Just head to Merchant Dashboard > Analytics Dashboard and view different trends.'
  ],
  validationMessage: {
    ifUserNameEmpty: "Username can not be empty!",
    ifPasswordEmpty: "Password can not be empty!",
    ifOtpEmpty: "OTP can not be empty!",
    ifUserNameHasEnoughChar: "Username should be more than 3 character!",
    ifPasswordHasEnoughChar: "password should be more than 3 character!",
    ifOtpHasEnoughChar: "OTP should be of 6 character!",
  },
  loginPageMessages: {
    title: "Welcome to LimeTray",
    subTitlePrimary: "It's good to see you again!",
    subTitleSecondary: " Type your login information and, we'll take you to your dashboard right away.",
    orContinueWith: "Or continue with",
    loginButtonText: "Login",
    forgotPasswordLink: "Forgot password?",
  },
  auth: {
    common: {
      backToSignIn: '← Back to sign in',
    },
    forgotPassword: {
      title: 'Forgot your password?',
      subtitle: "No worries. Enter your email and we'll send instructions to reset it.",
      emailLabel: 'Email',
      emailPlaceholder: 'you@example.com',
      submit: 'Send reset link',
      submitLoading: 'Sending…',
      resend: 'Resend',
      resendCooldown: 'Resend in {seconds}s',
      tryDifferentEmail: 'Try a different one',
      wrongEmailPrompt: 'Wrong email?',
      successTitle: 'Check your inbox',
      successSubtitle: 'We sent a password-reset link to {email}.',
      successExpiry: 'The link expires in 15 minutes.',
      errors: {
        invalidEmail: "That email doesn't look right. Check and try again.",
        emailRequired: "Email is required.",
        sendFailed: "Failed to send reset link. Please try again.",
      },
    },
    resetPassword: {
      title: "Set a new password",
      subtitle: "Choose a password that's hard to guess and easy to remember.",
      newPasswordLabel: "New password",
      confirmPasswordLabel: "Confirm new password",
      newPasswordPlaceholder: "Enter new password",
      confirmPasswordPlaceholder: "Confirm new password",
      reqLength: "Between 8 and 20 characters",
      reqLetterNumber: "At least one letter and one number",
      reqNoSpaces: "Must not contain spaces",
      reqNoSpecial: "No special characters",
      submit: "Reset password",
      submitLoading: "Resetting…",
      successTitle: "Password updated",
      successSubtitle:
        "You're good to go. Your password has been changed successfully—log in and get back to work.",
      successCta: "Continue to sign in",
      linkExpiredTitle: "Reset link expired",
      linkExpiredSubtitle:
        "This reset link is invalid or has expired. Request a new reset link to continue.",
      linkExpiredCta: "Request new link",
      showPassword: "Show",
      hidePassword: "Hide",
      errors: {
        confirmMismatch: "Passwords do not match.",
        tokenMissing:
          "This reset link is missing a token or it has expired. Request a new one from the login page.",
        resetFailed: "Could not reset your password. Please try again.",
      },
    },
  },
  sid: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJicmFuZFVzZXJJZCI6MTA4NTYyMTYsInVzZXJNb2JpbGUiOiI5NzE2MDM2MzM2IiwiaXNhIjoxNjY1NDA1NTg0OTExLCJicmFuZElkIjoiMCIsInVzZXJGdWxsTmFtZSI6IkFuZWVzaCBEZXZhc3RoYWxlIiwidXNlckVtYWlsIjoiYW5lZXNoQGxpbWV0cmF5LmNvbSIsInRva2VuVHlwZSI6ImlkIiwidXNlcklkIjoiNzdhNjc4NTYtYWYzYi0xMWU2LTg4ZjAtMDI4MjVmMTA0OGE1In0.-VVGk8HK6Ih9Ac7_S6Sj1jyXf10ZUy9JfBNTKYYrtCI',
}

export default appConstants;
